import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=5a03363c&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=5a03363c&prod&scoped=true&lang=css"
import style1 from "./Course.vue?vue&type=style&index=1&id=5a03363c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a03363c",
  null
  
)

export default component.exports